import { call, put, fork, takeLatest, select } from 'redux-saga/effects';
import {
  failureWeather,
  failurePastWeather,
  receivePastWeather,
  receiveHistoricalWeather,
} from '../actions/pastWeatherActions';
import {
  REQUEST_PAST_WEATHER,
  REQUEST_HISTORICAL_WEATHER,
} from '../constants/actionTypes';
import { requestPastWeather } from '../requesters/pastWeatherRequesters';

export function* getPastWeather() {
  try {
    const { field, pastWeather } = yield select();
    const { startDate, endDate } = pastWeather;
    const pastWeatherData = yield call(
      requestPastWeather,
      field.id,
      startDate,
      endDate
    );

    if (
      pastWeatherData &&
      pastWeatherData.errors &&
      pastWeatherData.errors.length > 0
    ) {
      yield put(failurePastWeather(pastWeatherData.errors));
    } else {
      yield put(receivePastWeather(pastWeatherData));
    }
  } catch (error) {
    yield put(failureWeather(error));
  }
}

export function* getHistoricalWeather() {
  try {
    const { field, pastWeather } = yield select();
    const { startDate, endDate, yearAverage } = pastWeather;
    const hitoricalWeatherData = yield call(
      requestPastWeather,
      field.id,
      startDate,
      endDate,
      'us',
      yearAverage
    );
    yield put(receiveHistoricalWeather(hitoricalWeatherData));
  } catch (error) {
    yield put(failureWeather(error));
  }
}

export function* getPastWeatherWatcher() {
  yield takeLatest(REQUEST_PAST_WEATHER, getPastWeather);
}

export function* getHistoricalWeatherWatcher() {
  yield takeLatest(REQUEST_HISTORICAL_WEATHER, getHistoricalWeather);
}

export default function* rootSaga() {
  yield fork(getPastWeatherWatcher);
  yield fork(getHistoricalWeatherWatcher);
}
